var _Date = {};
	_Date._msForSecond = 1000;
	_Date._msForMinute = 60000;
	_Date._msForHour = 3600000;
	_Date._msForDay = 86400000;
	_Date._msForWeek = 86400000 * 7;
var diff = function(start, end, interval) {
		switch (interval) {
		case 's':
			return parseInt((end - start) / _Date._msForSecond, 10);
		case 'n':
			return parseInt((end - start) / _Date._msForMinute, 10);
		case 'h':
			return parseInt((end - start) / _Date._msForHour, 10);
		case 'd':
			return parseInt((end - start) / _Date._msForDay, 10);
		case 'w':
			return parseInt((end - start) / _Date._msForWeek, 10);
		case 'm':
			return (end.getMonth() + 1) + ((end.getFullYear() - start.getFullYear()) * 12) - (start.getMonth() + 1);
		case 'y':
			return end.getFullYear() - start.getFullYear();
		}
	};
	
export default {
	now:function(){
		return new Date();
	},
	parse:function(millis){
        return new Date(millis);
    },
	getFullYear:function(date){
		if (!date) return null;
		return date.getFullYear();
	},
	getMonth:function(date){
		if (!date) return null;
		return date.getMonth() + 1;
	},
	getDay:function(date){
		if (!date) return null;
		return date.getDay();
	},
	getDayForChinese:function(date){
		if (!date) return null;
		var i = this.getDay(date);
		var ret = "星期日";
		if (i==1){
			ret = "星期一";
		}else if (i==2){
			ret = "星期二";
		}else if (i==3){
			ret = "星期三";
		}else if (i==4){
			ret = "星期四";
		}else if (i==5){
			ret = "星期五";
		}else if (i==6){
			ret = "星期六";
		}
		return ret;
	},
	getDate:function(date){
		if (!date) return null;
		return date.getDate();
	},
	getHour:function(date){
		if (!date) return null;
		return date.getHours();
	},
	getMinutes:function(date){
		if (!date) return null;
		return date.getMinutes();
	},
	getSeconds:function(date){
		if (!date) return null;
		return date.getSeconds();
	},
	getTime:function(date){
		if (!date) return null;
		return date.getTime();
	},
	setFullYear:function(date,years){
		if (!date) return null;
		return new Date(date.setFullYear(years));
	},
	setMonth:function(date,month){
		if (!date) return null;
		return new Date(date.setMonth(month-1));
	},
	setDate:function(date,day){
		if (!date) return null;
		return new Date(date.setDate(day));
	},
	setHours:function(date,hoursValue){
		if (!date) return null;
		return new Date(date.setHours(hoursValue));
	},
	setMinute:function(date,minutes){
		if (!date) return null;
		return new Date(date.setMinutes(minutes));
	},
	setSeconds:function(date,seconds){
		if (!date) return null;
		return new Date(date.setSeconds(seconds));
	},
	plusYears:function(date,years){
		if (!date) return null;
		let fullYear = date.getFullYear();
		return new Date(date.setFullYear(fullYear+years));
	},
	plusMonths:function(date,month){
		if (!date) return null;
		let currentMonth = date.getMonth();
		return new Date(date.setMonth(currentMonth + month));
	},
	plusHours:function(date,hours){
		if (!date) return null;
		let currentHours = date.getHours();
		return new Date(date.setHours(currentHours + hours));
	},
	plusDates:function(date,dates){
		if (!date) return null;
		let currentDay = date.getDate();
		return new Date(date.setDate(currentDay + dates));
	},
	plusMinutes:function(date,minutes){
		if (!date) return null;
		let currentMinutes = date.getMinutes();
		return new Date(date.setMinutes(currentMinutes + minutes));
	},
	plusSeconds:function(date,seconds){
		if (!date) return null;
		let currentSeconds = date.getSeconds();
		return new Date(date.setSeconds(currentSeconds + seconds)); 
	},
	plus:function(date,duration){
		if (!date) return null;
		let currentTimes = date.getTime();
		return new Date(currentTimes + duration);
	},
	fromNowYears:function(date){
		if (!date) return null;
		return this.yearsBetween(date,new Date());
	},
	fromNowMonths:function(date){
		if (!date) return null;
		return this.monthsBetween(date,new Date());
	},
	fromNowDays:function(date){
		if (!date) return null;
		return this.daysBetween(date,new Date());
	},
	fromNowWeeks:function(date){
		if (!date) return null;
		return this.monthsBetween(date,new Date());
	},
	fromNowHours:function(date){
		if (!date) return null;
		return this.hoursBetween(date,new Date());
	},
	fromNowMinutes:function(date){
		if (!date) return null;
		return this.minutesBetween(date,new Date());
	},
	fromNowSeconds:function(date){
		if (!date) return null;
		return this.secondsBetween(date,new Date());
	},
	yearsBetween:function(start,end){
		return diff(start,end,"y");
	},
	monthsBetween:function(start,end){
		return diff(start,end,"m");
	},
	daysBetween:function(start,end){
		return diff(start,end,"d");
	},
	hoursBetween:function(start,end){
		return diff(start,end,"h");
	},
	minutesBetween:function(start,end){
		return diff(start,end,"n");
	},
	secondsBetween:function(start,end){
		return diff(start,end,"s");
	}
}
